import _extends from "/var/lib/jenkins/jobs/EV/jobs/NextJS/jobs/02-cert-build/workspace/target/checkout/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/extends.js";
import _defineProperty from "/var/lib/jenkins/jobs/EV/jobs/NextJS/jobs/02-cert-build/workspace/target/checkout/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
var __jsx = React.createElement;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React, { createContext, useMemo, useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { selectUsersession } from "redux/reducers/userSessionReducer";
import { selectSearchHistoryState } from "redux/reducers/searchHistoryReducer";
import { selectSessionSettingsInitializeStatus } from "redux/reducers/sessionSettingsReducer";
export var STATUSVALUES = {
  INIT: "Init",
  AUTHENTICATING: "Authenticating",
  INITIALIZING: "Initializing",
  INITIALIZING_SESSION: "Initializing-session",
  ERROR: "Error",
  DONE: "Done"
};
var initials = {
  status: STATUSVALUES.INIT
};
export var AppContext = /*#__PURE__*/createContext({});
function AppContextProvider(props) {
  var _useState = useState(initials),
    context = _useState[0],
    setContext = _useState[1];
  var _useSelector = useSelector(selectUsersession),
    userSessionStatus = _useSelector.status,
    selectUsersessionData = _useSelector.data;
  var _ref = selectUsersessionData !== null && selectUsersessionData !== void 0 ? selectUsersessionData : {},
    _ref$user = _ref.user;
  _ref$user = _ref$user === void 0 ? {} : _ref$user;
  var associationType = _ref$user.associationType;
  var _useSelector2 = useSelector(selectSearchHistoryState),
    historyStatus = _useSelector2.status;
  var initializeStatus = useSelector(selectSessionSettingsInitializeStatus);
  var memoizedContextValue = useMemo(function () {
    return _objectSpread(_objectSpread({}, context), {}, {
      setContext: setContext
    });
  }, [context]);
  useEffect(function () {
    // Check Authentication
    if (userSessionStatus === "init" || userSessionStatus === "pending" || userSessionStatus === "needauth") {
      setContext({
        status: STATUSVALUES.AUTHENTICATING
      });
    }

    // Check history initialization
    else if (historyStatus === "init" && associationType && associationType !== "GUEST" || historyStatus === "pending" || initializeStatus !== "done") {
      setContext({
        status: STATUSVALUES.INITIALIZING
      });
    }

    // Check user session
    else if (userSessionStatus !== "done") {
      setContext({
        status: STATUSVALUES.INITIALIZING_SESSION
      });
    }

    // Check errors
    else if (userSessionStatus === "error") {
      setContext({
        status: STATUSVALUES.ERROR
      });
    }

    // Set app status to Done.
    else setContext({
      status: STATUSVALUES.DONE
    });
  }, [historyStatus, userSessionStatus, initializeStatus, associationType]);
  return /*#__PURE__*/React.createElement(AppContext.Provider, _extends({
    value: memoizedContextValue
  }, props));
}
export default AppContextProvider;